import React, { useContext } from 'react'; 
import classnames from 'classnames'; 
import { ArrowRight, ArrowLeft, ChevronRight, ChevronLeft } from 'react-feather'; 
import StrapiLinkUnstyled from '../StrapiLink/StrapiLinkUnstyled'; 
import { Maybe } from '../../../graphql.schema'; 
import { PageContext } from '../PageContext'; 
import { v4tov3base } from '../../lib/mapV4toV3'; 
import * as styles from './Button.module.scss'; 

export type ButtonProps = { 
  type?: 'primary' | 'secondary'; 
  hideIcon?: boolean; 
  icon?: 'Arrow' | 'Chevron'; 
  openInNewWindow?: Maybe<boolean> | undefined; 
} & React.HTMLProps<HTMLAnchorElement>; 

const Button: React.FC<ButtonProps> = ({ children, icon='Arrow', hideIcon = false, type, openInNewWindow = false, ...props }) => { 
  const { websiteLocale } = useContext(PageContext); 
  const { hasRightToLeftLanguage } = v4tov3base({...websiteLocale.attributes}); 
  return ( 
    <StrapiLinkUnstyled 
      className={classnames(styles.root, props.className, { 
        [styles.secondary]: type === 'secondary', 
      }) 
    } 
      openInNewWindow={openInNewWindow} 
      url={props.href} 
    > 
      <span className={styles.content}>{children}</span> 
      {hasRightToLeftLanguage ?  
      (hideIcon ? null : icon === 'Arrow' ? <ArrowLeft size={24} data-testid="arrow-left" /> : <ChevronLeft size={24} data-testid="chevron-left"/>): 
      (hideIcon ? null : icon === 'Arrow' ? <ArrowRight size={24} data-testid="arrow-right"/> : <ChevronRight size={24} data-testid="chevron-right"/>)} 
    </StrapiLinkUnstyled>  
  ); 
}; 

export default Button; 
